'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('clinic.settings', {
    url: 'settings/?tab',
    templateUrl: '/views/partials/clinic/settings.html',
    controller: 'ClinicSettingsCtrl',
    resolve: {
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Settings - ' + clinic.name + ' - Opencare');
      },
      permissions: function($stateParams, ClinicService) {
        return ClinicService.getClinicPermissions($stateParams.id);
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicSettingsCtrl', function(
  $scope,
  $state,
  $stateParams,
  permissions,
  ClinicConfig,
  ClinicService,
  CurrentUser,
  clinic,
  IframeService,
  ServiceWorkerService,
  OCLogUtil,
  OCModalUtil,
) {
  const settingsUrl = `${ClinicConfig.CLINIC_APP_V4_URL}/#/clinic/${clinic.id}/settings?tab=${$state.params.tab}`;
  const iframeElement = angular.element('#js-settings-iframe')[0];
  iframeElement.src = encodeURI(settingsUrl);

  IframeService.addResizeHandler({
    getElement: () => document.getElementById('settings-container'),
    isApplicable: () => true,
  });

  const sendMessage = (type, data) => {
    IframeService.sendMessage({ type, data, iframe: iframeElement });
  };

  IframeService.onMessage('getPushNotificationStatus', () => {
    const status = ServiceWorkerService.getStatus();
    try {
      sendMessage('pushNotificationStatus', { status });
    } catch (error) {
      OCLogUtil.rollbar.error('Error getting push notification status', error);
      sendMessage('pushNotificationStatus', { error });
    }
  });

  IframeService.onMessage('disablePushNotifications', async () => {
    try {
      await ServiceWorkerService.disableNotifications();
      sendMessage('pushNotificationsDisabledResult');
    } catch (error) {
      OCLogUtil.rollbar.error('Error disabling push notifications', error);
      sendMessage('pushNotificationsDisabledResult', { error });
    }
  });

  IframeService.onMessage('enablePushNotifications', async () => {
    try {
      await ServiceWorkerService.enableNotifications();
      sendMessage('pushNotificationsEnabledResult');
    } catch (error) {
      OCLogUtil.rollbar.error('Error enabling push notifications', error);
      sendMessage('pushNotificationsEnabledResult', { error });
    }
  });

  IframeService.onMessage('openDisableAiModal', async () => {
    OCModalUtil.showModal('disableAi', { clinicId: clinic.id });
  });

  IframeService.onMessage('goToProfile', async () => {
    $state.go('clinic.profile');
  });

  OpencareAnalytics.trackPageView({
    pageType: OpencareAnalytics.pageTypes.SETTINGS_MANAGER,
    pageName: clinic.name,
    content: {
      view: 'practice',
      is_real_practice: String(!CurrentUser.isImpersonated()),
    },
    practiceId: clinic.id,
    userId: CurrentUser.getUser().id,
  });

  $scope.permissions = permissions;

  $scope.$on('reloadPermissions', function() {
    ClinicService.getClinicPermissions($stateParams.id).then(function(permissions) {
      $scope.permissions = permissions;
    });
  });

  $scope.onDelete = function() {
    $state.go('home');
  };
});
